import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  MessageRow,
  MessageBubble,
  MessageFigureWrapButton,
  MessageFigureImage,
  MessageImagePreviewOverlay,
  MessageImagePreviewContent,
  MessageImagePreviewCloseButton,
  MessageImagePreviewImg,
  MessageSourcesText,
  SourceAnchor,
  SourceUnavailableText,
} from './chatbot.styled';

const MESSAGE_DEFAULTS = {
  'chatbot.initialGreeting': "Hello! I'm {{partnerName}} AI. I have access to your plant health data and reliability documentation. How can I help you today?",
  'chatbot.errors.sendFailed': 'Sorry, something went wrong: {{error}}',
};

const ChatMessage = ({ message }) => {
  const { t } = useTranslation();
  const isBot = message.sender === 'bot';
  const imageSrc = isBot && message.imageUrl ? message.imageUrl : null;
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const messageText = message.textKey
    ? t(message.textKey, {
      ...(message.textValues || {}),
      defaultValue: MESSAGE_DEFAULTS[message.textKey],
    })
    : message.text;

  return (
    <MessageRow isBot={isBot}>
      <MessageBubble isBot={isBot}>
        {messageText}
      </MessageBubble>
      {isBot && message.sources && message.sources.length > 0 && (
        <MessageSourcesText>
          {t('chatbot.sources.label')}{' '}
          {message.sources.map((src, i) => (
            <span key={src.document_version_id ? `${src.document_version_id}-${i}` : `src-${i}`}>
              {src.source_download_url ? (
                <SourceAnchor
                  href={src.source_download_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {src.displayLabel || t(src.displayLabelKey || 'chatbot.sources.defaultSource', { defaultValue: 'Source' })}
                </SourceAnchor>
              ) : (
                <SourceUnavailableText>{t('chatbot.sources.unavailable')}</SourceUnavailableText>
              )}
            </span>
          ))}
        </MessageSourcesText>
      )}
      {imageSrc && (
        <MessageFigureWrapButton
          type="button"
          onClick={() => setIsPreviewOpen(true)}
          aria-label={t('chatbot.aria.openImagePreview')}
        >
          <MessageFigureImage src={imageSrc} alt={t('chatbot.image.figureAlt')} />
        </MessageFigureWrapButton>
      )}
      {imageSrc && isPreviewOpen && (
        <MessageImagePreviewOverlay
          role="button"
          tabIndex={0}
          onClick={() => setIsPreviewOpen(false)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setIsPreviewOpen(false);
            }
          }}
        >
          <MessageImagePreviewContent
            onClick={e => e.stopPropagation()}
            onKeyDown={() => {}}
            role="presentation"
          >
            <MessageImagePreviewCloseButton
              type="button"
              onClick={() => setIsPreviewOpen(false)}
              aria-label={t('chatbot.aria.closeImagePreview')}
            >
              x
            </MessageImagePreviewCloseButton>
            <MessageImagePreviewImg
              src={imageSrc}
              alt={t('chatbot.image.figurePreviewAlt')}
            />
          </MessageImagePreviewContent>
        </MessageImagePreviewOverlay>
      )}
    </MessageRow>
  );
};

export default ChatMessage;
